import React from 'react';
import { withRouter } from 'react-router-dom';
import { withStyles, Grid, Typography, Table, TableHead, TableRow, TableCell, TableBody, } from '@material-ui/core';
import MSectionHeader from '../../view/MSectionHeader';
import Apis from '../../../network/Apis';


import ICON_PLAYING from '../../../images/bg/img_football_formation.png';
import MPlayer from '../../view/MPlayer';


class MovieTeamFootball extends React.Component {

    constructor(props) {
        super(props);
        this.state = { playerData: [], formations: null };
        console.log('MovieTeamFootball', props);
    }


    componentDidMount() {
        let { matchId, matchType } = this.props.match.params;
        const { data } = this.props;
        if (matchType == 0 && data) {
            matchType = data.match_type;
        }
        if (matchId == 0 && data) {
            matchId = data.match_id;
        }
        this.getFootballPlayers(matchType, matchId);
        this.getMatchFormation(matchType, matchId);
    }

    componentWillUnmount() {
        this.setState = () => false;
    }

    getMatchFormation = async (type, id) => {
        let result = await Apis.encryptionMatchLineUp(type, id);
        console.log('getMatchFormation', result);
        if (result.code == 200) {
            this.setState({ formations: result.data });
        }
    }

    getFootballPlayers = async (match_type, match_id) => {
        let result = await Apis.encryptionPlayerStats(match_type, match_id);
        console.log('getFootballPlayers', result);
        if (result.code == 200) {
            console.log(typeof (result.data));
            let data = [];
            if (result.data.player_stats && result.data.player_stats.length > 0) {
                let players = result.data.player_stats;
                let homePlayers = [];
                let awayPlayers = [];
                for (let i = 0; i < players.length; i++) {
                    if (players[i].team_id == this.props.data.home_team_id) {
                        homePlayers.push(players[i]);
                    } else {
                        awayPlayers.push(players[i]);
                    }
                }
                data.push(homePlayers);
                data.push(awayPlayers);

                // for (let i = 0; i < players.length && i < 2; i++) {
                //     let tmp = [];
                //     for (let j = 0; j < players[i].length; j++) {
                //         const element = players[i][j];
                //         let obj = {
                //             team_id: element.team_id,
                //             player_id: element.player_id,
                //             first: element.first,
                //             goals: element.goals,
                //             penalty: element.penalty,
                //             assists: element.assists,
                //             minutes_played: element.minutes_played,
                //             red_cards: element.red_cards,
                //             yellow_cards: element.yellow_cards,
                //             shots: element.shots,
                //             shots_on_target: element.shots_on_target,
                //             dribble: element.dribble,
                //             dribble_succ: element.dribble_succ,
                //             clearances: element.clearances,
                //             blocked_shots: element.blocked_shots,
                //             interceptions: element.interceptions,
                //             tackles: element.tackles,
                //             passes: element.passes,
                //             passes_accuracy: element.passes_accuracy,
                //             key_passes: element.key_passes,
                //             crosses: element.crosses,
                //             crosses_accuracy: element.crosses_accuracy,
                //             long_balls: element.long_balls,
                //             long_balls_accuracy: element.long_balls_accuracy,
                //             duels: element.duels,
                //             duels_won: element.duels_won,
                //             dispossessed: element.dispossessed,
                //             fouls: element.fouls,
                //             was_fouled: element.was_fouled,
                //             saves: element.saves,
                //             punches: element.punches,
                //             runs_out: element.runs_out,
                //             runs_out_succ: element.runs_out_succ,
                //             good_high_claim: element.good_high_claim,
                //             rating: element.rating,
                //             name: element.name,
                //         }
                //         tmp.push(obj);
                //     }
                //     data.push(tmp);
                // }
            }
            this.setState({ playerData: data });
        }
    }

    _readerHeader() {
        const { classes } = this.props;
        return (
            <TableRow style={{ backgroundColor: '#E9F9FF' }}>
                <TableCell align='center' className={classes.tableHead}>球员</TableCell>
                <TableCell align='center' className={classes.tableHead}>首发</TableCell>
                <TableCell align='center' className={classes.tableHead}>进球</TableCell>
                <TableCell align='center' className={classes.tableHead}>点球</TableCell>
                <TableCell align='center' className={classes.tableHead}>助攻</TableCell>
                <TableCell align='center' className={classes.tableHead}>时间</TableCell>
                <TableCell align='center' className={classes.tableHead}>红牌</TableCell>
                <TableCell align='center' className={classes.tableHead}>黄牌</TableCell>
                <TableCell align='center' className={classes.tableHead}>射门</TableCell>
                <TableCell align='center' className={classes.tableHead}>射正</TableCell>
                <TableCell align='center' className={classes.tableHead}>过人</TableCell>
                <TableCell align='center' className={classes.tableHead}>过人成功</TableCell>
                <TableCell align='center' className={classes.tableHead}>解围</TableCell>
                <TableCell align='center' className={classes.tableHead}>有效阻挡</TableCell>
                <TableCell align='center' className={classes.tableHead}>拦截</TableCell>
                <TableCell align='center' className={classes.tableHead}>抢断</TableCell>
                <TableCell align='center' className={classes.tableHead}>传球</TableCell>
                <TableCell align='center' className={classes.tableHead}>传球成功</TableCell>
                <TableCell align='center' className={classes.tableHead}>传中球</TableCell>
                <TableCell align='center' className={classes.tableHead}>传中球成功</TableCell>
                <TableCell align='center' className={classes.tableHead}>长传</TableCell>
                <TableCell align='center' className={classes.tableHead}>长传成功</TableCell>
                <TableCell align='center' className={classes.tableHead}>拼抢</TableCell>
                <TableCell align='center' className={classes.tableHead}>拼抢成功</TableCell>
                <TableCell align='center' className={classes.tableHead}>丢球</TableCell>
                <TableCell align='center' className={classes.tableHead}>犯规</TableCell>
                <TableCell align='center' className={classes.tableHead}>被侵犯</TableCell>
                <TableCell align='center' className={classes.tableHead}>扑救</TableCell>
                <TableCell align='center' className={classes.tableHead}>拳击球</TableCell>
                <TableCell align='center' className={classes.tableHead}>守门员出击</TableCell>
                <TableCell align='center' className={classes.tableHead}>出击成功</TableCell>
                <TableCell align='center' className={classes.tableHead}>高空出击</TableCell>
                <TableCell align='center' className={classes.tableHead}>评分</TableCell>
            </TableRow>
        );
    }

    _renderItem(item, i) {
        const { classes } = this.props;
        return (
            <TableRow key={i} style={{ backgroundColor: i % 2 == 0 ? '#FFF' : '#F9F9F9' }}>
                <TableCell align='center' className={classes.tableBody}>{item.name ? item.name : item.player_id}</TableCell>
                <TableCell align='center' className={classes.tableBody}>{item.first == '1' ? '是' : '否'}</TableCell>
                <TableCell align='center' className={classes.tableBody}>{item.goals}</TableCell>
                <TableCell align='center' className={classes.tableBody}>{item.penalty}</TableCell>
                <TableCell align='center' className={classes.tableBody}>{item.assists}</TableCell>
                <TableCell align='center' className={classes.tableBody}>{item.minutes_played}</TableCell>
                <TableCell align='center' className={classes.tableBody}>{item.red_cards}</TableCell>
                <TableCell align='center' className={classes.tableBody}>{item.yellow_cards}</TableCell>
                <TableCell align='center' className={classes.tableBody}>{item.shots}</TableCell>
                <TableCell align='center' className={classes.tableBody}>{item.shots_on_target}</TableCell>
                <TableCell align='center' className={classes.tableBody}>{item.dribble}</TableCell>
                <TableCell align='center' className={classes.tableBody}>{item.dribble_succ}</TableCell>
                <TableCell align='center' className={classes.tableBody}>{item.clearances}</TableCell>
                <TableCell align='center' className={classes.tableBody}>{item.blocked_shots}</TableCell>
                <TableCell align='center' className={classes.tableBody}>{item.interceptions}</TableCell>
                <TableCell align='center' className={classes.tableBody}>{item.tackles}</TableCell>
                <TableCell align='center' className={classes.tableBody}>{item.passes}</TableCell>
                <TableCell align='center' className={classes.tableBody}>{item.passes_accuracy}</TableCell>
                <TableCell align='center' className={classes.tableBody}>{item.crosses}</TableCell>
                <TableCell align='center' className={classes.tableBody}>{item.crosses_accuracy}</TableCell>
                <TableCell align='center' className={classes.tableBody}>{item.long_balls}</TableCell>
                <TableCell align='center' className={classes.tableBody}>{item.long_balls_accuracy}</TableCell>
                <TableCell align='center' className={classes.tableBody}>{item.duels}</TableCell>
                <TableCell align='center' className={classes.tableBody}>{item.duels_won}</TableCell>
                <TableCell align='center' className={classes.tableBody}>{item.dispossessed}</TableCell>
                <TableCell align='center' className={classes.tableBody}>{item.fouls}</TableCell>
                <TableCell align='center' className={classes.tableBody}>{item.was_fouled}</TableCell>
                <TableCell align='center' className={classes.tableBody}>{item.saves}</TableCell>
                <TableCell align='center' className={classes.tableBody}>{item.punches}</TableCell>
                <TableCell align='center' className={classes.tableBody}>{item.runs_out}</TableCell>
                <TableCell align='center' className={classes.tableBody}>{item.runs_out_succ}</TableCell>
                <TableCell align='center' className={classes.tableBody}>{item.good_high_claim}</TableCell>
            </TableRow>
        );
    }

    renderFirst() {
        const { classes } = this.props;
        const { playerData, formations } = this.state;
        let homePlayers = playerData[0];
        let awayPlayers = playerData[1];
        let propsData = this.props.data;
        let home_name = '';
        let away_name = '';
        let home_logo = '';
        let away_logo = '';
        if (propsData) {
            home_name = propsData.home_name;
            away_name = propsData.away_name;
            home_logo = propsData.home_log;
            away_logo = propsData.away_log;
        }

        let hPlayers = [];
        let tbHomePlayers = [];
        if (formations.home) {
            hPlayers = formations.home.filter((item) => {
                return item.first == 1;
            })
            tbHomePlayers = formations.home.filter((item) => {
                return item.first != 0;
            })
        }


        let aPlayers = [];
        let tbAwayPlayers = [];
        if (formations.away) {
            aPlayers = formations.away.filter((item) => {
                return item.first == 1;
            })
            tbAwayPlayers = formations.away.filter((item) => {
                return item.first != 0;
            })
        }

        let tbPlayer = tbHomePlayers.length > tbAwayPlayers.length ? tbHomePlayers : tbAwayPlayers;

        return (
            <Grid container direction='column' alignItems='center'>
                <MSectionHeader title={'首发阵容'} />
                <Grid container direction='row' alignItems='center'>
                    <Grid container direction='row' alignItems='center' style={{ maxWidth: '50%', paddingLeft: 8 }}>
                        <img src={home_logo} style={{ width: 25, height: 25, objectFit: 'scale-down' }}></img>
                        <Typography style={{ fontSize: 12, color: '#080808', marginLeft: 4 }}>{home_name}</Typography>
                    </Grid>
                    <Grid container direction='row' alignItems='center' justifyContent='flex-end' style={{ flex: 1, paddingRight: 8 }}>
                        <Typography style={{ fontSize: 9, color: '#080808' }}>{'阵型' + formations.home_formation}</Typography>
                    </Grid>
                </Grid>
                <Grid container direction='column' alignItems='center' justifyContent='space-between' style={{
                    width: 'calc(100vw - 16px)',
                    height: '200vw',
                    marginTop: 8,
                    marginBottom: 8,
                    backgroundSize: 'calc(100vw - 16px) 200vw',
                    backgroundImage: `url(${ICON_PLAYING})`,
                    backgroundRepeat: 'no-repeat',
                }}>
                    <Grid container direction='column' alignItems='center' justifyContent='flex-end' style={{ height: '100vw' }}>
                        <Grid container direction='row' alignItems='center' justifyContent='center' style={{ height: '25vw' }}>
                            {
                                hPlayers[0] && <MPlayer name={hPlayers[0].name} num={hPlayers[0].shirt_number} position={0} />
                            }
                        </Grid>
                        <Grid container direction='row' justifyContent='space-around' style={{ height: '25vw' }}>
                            {
                                hPlayers[1] && <MPlayer name={hPlayers[1].name} num={hPlayers[1].shirt_number} position={0} />
                            }
                            {
                                hPlayers[2] && <MPlayer name={hPlayers[2].name} num={hPlayers[2].shirt_number} position={0} />
                            }
                            {
                                hPlayers[3] && <MPlayer name={hPlayers[3].name} num={hPlayers[3].shirt_number} position={0} />
                            }
                            {
                                hPlayers[4] && <MPlayer name={hPlayers[4].name} num={hPlayers[4].shirt_number} position={0} />
                            }
                        </Grid>
                        <Grid container direction='row' justifyContent='space-around' style={{ height: '25vw' }}>
                            {
                                hPlayers[5] && <MPlayer name={hPlayers[5].name} num={hPlayers[5].shirt_number} position={0} />
                            }
                            {
                                hPlayers[6] && <MPlayer name={hPlayers[6].name} num={hPlayers[6].shirt_number} position={0} />
                            }
                            {
                                hPlayers[7] && <MPlayer name={hPlayers[7].name} num={hPlayers[7].shirt_number} position={0} />
                            }
                        </Grid>
                        <Grid container direction='row' alignItems='center' justifyContent='center' style={{ height: '25vw' }}>
                            {
                                hPlayers[8] && <MPlayer name={hPlayers[8].name} num={hPlayers[8].shirt_number} position={0} />
                            }
                            <Grid style={{ marginBottom: 50 }}>
                                {
                                    hPlayers[9] && <MPlayer name={hPlayers[9].name} num={hPlayers[9].shirt_number} position={0} />
                                }
                            </Grid>
                            {
                                hPlayers[10] && <MPlayer name={hPlayers[10].name} num={hPlayers[10].shirt_number} position={0} />
                            }
                        </Grid>
                    </Grid>
                    <Grid container direction='column' alignItems='center' justifyContent='flex-start' style={{ height: '100vw' }}>
                        <Grid container direction='row' alignItems='center' justifyContent='center' style={{ height: '25vw' }}>
                            <Grid style={{ marginBottom: 50 }}>
                                {
                                    aPlayers[10] && <MPlayer name={aPlayers[10].name} num={aPlayers[10].shirt_number} position={1} />
                                }
                            </Grid>
                            {
                                aPlayers[9] && <MPlayer name={aPlayers[9].name} num={aPlayers[9].shirt_number} position={1} />
                            }
                            <Grid style={{ marginBottom: 50 }}>
                                {
                                    aPlayers[8] && <MPlayer name={aPlayers[8].name} num={aPlayers[8].shirt_number} position={1} />
                                }
                            </Grid>
                        </Grid>
                        <Grid container direction='row' justifyContent='space-around' style={{ height: '25vw' }}>
                            {
                                aPlayers[7] && <MPlayer name={aPlayers[7].name} num={aPlayers[7].shirt_number} position={1} />
                            }
                            {
                                aPlayers[6] && <MPlayer name={aPlayers[6].name} num={aPlayers[6].shirt_number} position={1} />
                            }
                            {
                                aPlayers[5] && <MPlayer name={aPlayers[5].name} num={aPlayers[5].shirt_number} position={1} />
                            }
                        </Grid>
                        <Grid container direction='row' justifyContent='space-around' style={{ height: '25vw' }}>
                            {
                                aPlayers[4] && <MPlayer name={aPlayers[4].name} num={aPlayers[4].shirt_number} position={1} />
                            }
                            {
                                aPlayers[3] && <MPlayer name={aPlayers[3].name} num={aPlayers[3].shirt_number} position={1} />
                            }
                            {
                                aPlayers[2] && <MPlayer name={aPlayers[2].name} num={aPlayers[2].shirt_number} position={1} />
                            }
                            {
                                aPlayers[1] && <MPlayer name={aPlayers[1].name} num={aPlayers[1].shirt_number} position={1} />
                            }
                        </Grid>
                        <Grid container direction='row' alignItems='center' justifyContent='center' style={{ height: '25vw' }}>
                            {
                                aPlayers[0] && <MPlayer name={aPlayers[0].name} num={aPlayers[0].shirt_number} position={1} />
                            }
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container direction='row' alignItems='center'>
                    <Grid container direction='row' alignItems='center' style={{ maxWidth: '50%', paddingLeft: 8 }}>
                        <img src={away_logo} style={{ width: 25, height: 25, objectFit: 'scale-down' }}></img>
                        <Typography style={{ fontSize: 12, color: '#0D0D0D', marginLeft: 4 }}>{away_name}</Typography>
                    </Grid>
                    <Grid container direction='row' alignItems='center' justifyContent='flex-end' style={{ flex: 1, paddingRight: 8 }}>
                        <Typography style={{ fontSize: 9, color: '#080808' }}>{'阵型' + formations.away_formation}</Typography>
                    </Grid>
                </Grid>
                <MSectionHeader title={'替补阵容'} />
                <Table>
                    <TableHead>
                        <TableRow style={{ backgroundColor: '#E9F9FF' }}>
                            <TableCell colSpan={2} align='center'>{home_name}</TableCell>
                            <TableCell colSpan={2} align='center'>{away_name}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            tbPlayer.map((item, i) => (
                                <TableRow key={i} style={{ backgroundColor: i % 2 == 0 ? '#FFF' : '#F9F9F9' }}>
                                    <TableCell align='center' style={{ color: '#FC2E34', fontSize: 12, minWidth: 12 }}>
                                        {tbHomePlayers[i] ? tbHomePlayers[i].shirt_number : ''}
                                    </TableCell>
                                    <TableCell align='left' style={{ color: '#0E0E0E', fontSize: 12 }}>
                                        {tbHomePlayers[i] ? tbHomePlayers[i].name : ''}
                                    </TableCell>
                                    <TableCell align='center' style={{ color: '#368CF4', fontSize: 12, minWidth: 12 }}>
                                        {tbAwayPlayers[i] ? tbAwayPlayers[i].shirt_number : ''}
                                    </TableCell>
                                    <TableCell align='left' style={{ color: '#0E0E0E', fontSize: 12 }}>
                                        {tbAwayPlayers[i] ? tbAwayPlayers[i].name : ''}
                                    </TableCell>
                                </TableRow>
                            ))
                        }
                    </TableBody>
                </Table>
            </Grid>
        );
    }

    render() {
        const { classes } = this.props;
        const { playerData, formations } = this.state;
        let homePlayers = playerData[0];
        let awayPlayers = playerData[1];
        const home_name = this.props.data.home_name ? this.props.data.home_name : '';
        const away_name = this.props.data.away_name ? this.props.data.away_name : '';

        return (
            <Grid container direction='column' alignItems='center' justifyContent='center' className={classes.root}>
                {
                    formations && this.renderFirst()
                }
                <MSectionHeader title={'球员统计-' + home_name} />
                <div style={{ overflowX: 'scroll', width: '100vw' }} >
                    <Table>
                        <TableHead>
                            {
                                this._readerHeader()
                            }
                        </TableHead>
                        <TableBody>
                            {
                                homePlayers && homePlayers.map((item, i) => (
                                    this._renderItem(item, i)
                                ))
                            }
                        </TableBody>
                    </Table>
                </div>
                <MSectionHeader title={'球员统计-' + away_name} />
                <div style={{ overflowX: 'scroll', width: '100vw' }}>
                    <Table>
                        <TableHead>
                            {
                                this._readerHeader()
                            }
                        </TableHead>
                        <TableBody>
                            {
                                awayPlayers && awayPlayers.map((item, i) => (
                                    this._renderItem(item, i)
                                ))
                            }
                        </TableBody>
                    </Table>
                </div>
            </Grid>
        );
    }
}

export default withRouter(withStyles((theme) => ({
    root: {
        width: '100%',
        backgroundColor: '#FFF'
    },
    tableHead: {
        fontSize: 7,
        color: '#898989',
        height: 36,
        margin: theme.spacing(0, 0, 0, 0),
        padding: theme.spacing(0, 2, 0, 2),
        border: 0,
        minWidth: 80,
    },
    tableBody: {
        fontSize: 9,
        color: '#0D0D0D',
        margin: theme.spacing(0, 0, 0, 0),
        padding: theme.spacing(1, 0, 1, 0),
        border: 0,
        height: 24,
        minWidth: 80,
    },

}))(MovieTeamFootball));